import { STATE_WORD, type SpecRowState } from "../../lib/specLines";

// A row's one state (0051 slice 3): its word, never colour alone. The colour is
// a theme role or ink (0175): a blocker reads danger, a waiting act warn, a
// confirmed decision ok, a saved item and a turned-down one ink.
const STATE_CLASS: Record<SpecRowState, string> = {
  blocked: "text-danger",
  open: "text-warn",
  proposed: "text-warn",
  confirmed: "text-ok",
  answered: "text-ink-300",
  saved: "text-ink-300",
  rejected: "text-ink-400",
};

export function StateChip({ state }: { state: SpecRowState }) {
  return (
    <span
      data-testid="state-chip"
      data-state={state}
      className={`${STATE_CLASS[state]} border border-ink-700 rounded-sm px-1.5 py-0.5 font-mono text-[10px] uppercase tracking-widest whitespace-nowrap`}
    >
      {STATE_WORD[state]}
    </span>
  );
}
